import { useState } from 'react';

const useMobileTabState = () => {
  const [scannedList, setScannedList] = useState(true);
  const [unScannedList, setUnScannedList] = useState(false);
  const [logList, setLogList] = useState(false);

  const showScannedListTab = () => {
    setScannedList(true);
    setUnScannedList(false);
    setLogList(false);
  };

  const showUnScannedListTab = () => {
    setScannedList(false);
    setUnScannedList(true);
    setLogList(false);
  };

  const showLogListTab = () => {
    setScannedList(false);
    setUnScannedList(false);
    setLogList(true);
  };

  return {
    scannedList,
    unScannedList,
    logList,
    showScannedListTab,
    showUnScannedListTab,
    showLogListTab,
  };
};

export default useMobileTabState;
